import React, { useEffect, useRef, useState } from "react";
import { Card, Space, AutoComplete, Button } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import "../ECatalogComponents/productslide.css";

import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BsCartPlus } from "react-icons/bs";
import { useCart } from 'react-use-cart';
import { GetAllMasterCategotryGroup } from "../../Services/EcatalogService";
import iconCategory from '../../assets/categories.png';
import { CgEnter } from "react-icons/cg";
// import Carousel from 'react-bootstrap/Carousel';
// import bs from 'react-bootstrap'
// import $ from 'jquery';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const { Meta } = Card;

interface Props {

}

export default function ProductCatalog(props: Props) {
  const [productCategory, setProductCategory] = useState<any[]>([]);
  const customSlider = useRef<Slider>(null);

  const history = useHistory();
  useEffect(() => {
    getProductCategory();

  }, [])

  async function getProductCategory() {
    const response = await GetAllMasterCategotryGroup({CategoryGroupID: null});
    //console.log();

    //const response = await fetch('https://dummyjson.com/products/category-list')  // fetch the products
    //const data = await response.json() // convert the response to json
    const data = response.data;
    setProductCategory(data); // set the products in the state to the products we fetched

    // var carouselWidth = $(".carousel-inner")[0].scrollWidth;
    // var cardWidth = $(".carousel-item").width();
    // var scrollPosition = 0;
    // $(".carousel-control-next").on("click", function () {
    //   if (scrollPosition < (carouselWidth - cardWidth * 4)) { //check if you can go any further
    //     scrollPosition += cardWidth;  //update scroll position
    //     $(".carousel-inner").animate({ scrollLeft: scrollPosition },600); //scroll left
    //   }
    // });
    // $(".carousel-control-prev").on("click", function () {
    //   if (scrollPosition > 0) {
    //     scrollPosition -= cardWidth;
    //     $(".carousel-inner").animate(
    //       { scrollLeft: scrollPosition },
    //       600
    //     );
    //   }
    // });

    // var multipleCardCarousel = document.querySelector(
    //   "#carouselExampleControls"
    // );
    // if (window.matchMedia("(min-width: 768px)").matches) {
    //   //rest of the code
    //   var carousel = new bootstrap.Carousel(multipleCardCarousel, {
    //     interval: false
    //   });
    // } else {
    //   $(multipleCardCarousel).addClass("slide");
    // }
    // var carousel = new bootstrap.Carousel(multipleCardCarousel, {
    //   interval: false,
    //   // wrap: false,
    // });
  }

  var settings = {
    rows: 1,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 0,
    infinite: true,
    prevArrow: <FaAngleLeft />,
    nextArrow: <FaAngleRight />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 7,
      slidesToSlide: 7, // optional, default to 1.
      partialVisibilityGutter: 40
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: 3, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 767, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
  };
  return (
    <>
      {/* <Carousel className="temp-carousel" id="carouselExampleControls">
        <Carousel.Item>
          <div className="card">
          <div class="img-wrapper">
            <img src="..." className="d-block w-100" alt="..." />
          </div>
           
            <div className="card-body">
                <h5 className="card-title">Card title 1</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
            <div className="card">
            <div class="img-wrapper">
            <img src="..." className="d-block w-100" alt="..." />
          </div>
                <div className="card-body">
                    <h5 className="card-title">Card title 2</h5>
                    <p className="card-text">Some quick example text to build on the card title and make up the bulk of the
                        card's content.</p>
                    <a href="#" className="btn btn-primary">Go somewhere</a>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
        <div className="card">
        <div class="img-wrapper">
            <img src="..." className="d-block w-100" alt="..." />
          </div>
            <div className="card-body">
                <h5 className="card-title">Card title 3</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
        <div className="card">
        <div class="img-wrapper">
            <img src="..." className="d-block w-100" alt="..." />
          </div>
            <div className="card-body">
                <h5 className="card-title">Card title 4</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
            </div>
        </div>
        </Carousel.Item>
        <Carousel.Item>
        <div className="card">
        <div class="img-wrapper">
            <img src="..." className="d-block w-100" alt="..." />
          </div>
            <div className="card-body">
                <h5 className="card-title">Card title 5</h5>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                <a href="#" className="btn btn-primary">Go somewhere</a>
            </div>
        </div>
        </Carousel.Item>
      </Carousel>
      id="carouselExampleControls" */}
      <div style={{ width: "100%", padding: "0px 20px" }} className="ant-card-body">
    

        {/* <Slider ref={customSlider} {...settings} className="slider-product-catalog">
          {
            productCategory && productCategory.map((product:any) => (
              <Card key={product.rowID}
                hoverable
                className="slide-custom-card"
                style={{ width: "200px", borderRadius: "5px" }}
                cover={<img alt="example" src={product.thumbnail} style={{width: "50%", display: "block", marginLeft: "auto", marginRight: "auto" }}   />}
                onClick={() => { history.push(`/productbycategory?category=${product.Text}`); }}
              >
                  <div style={{ textAlign: "center"}}>
                    <img src={iconCategory} style={{margin: "0 auto"}}></img>
                  <div style={{fontWeight: 600}}>{product.Text}</div>
                  </div>
               
              </Card>
            ))
          }
        </Slider> */}
        <Carousel
          responsive={responsive}
          autoPlay={true}
          swipeable={true}
          draggable={true}
          showDots={true}
          infinite={true}
          partialVisible={false}
        >
         {productCategory.map((item, index) => {
          return (
            // <div className="slider" key={index}>
            //   {/* <img src={imageUrl.url} alt="movie" /> */}
            //   {item.CategoryGroupName}
            // </div>
            <Card key={index}
                hoverable
                className="slide-custom-card"
                style={{ width: "200px", borderRadius: "5px" }}
                //cover={<img alt="example" src={item.thumbnail} style={{width: "50%", display: "block", marginLeft: "auto", marginRight: "auto" }}   />}
                onClick={() => { history.push(`/searchproduct?catid=${item.CategoryGroupCode}&cattxt=${item.CategoryGroupName}`); }}
              >
                  <div style={{ textAlign: "center"}}>
                    <img src={iconCategory} style={{margin: "0 auto"}}></img>
                  <div style={{fontWeight: 600}}>{item.CategoryGroupName}</div>
                  </div>
               
              </Card>
          )
        })}
        </Carousel>
        <Space style={{ display: "flex" }} wrap>
        </Space>
      </div>
    </>
  )
};